export default {"src":"/_next/static/media/whoop-logo.429bd3c1.svg","height":23,"width":141,"blurWidth":0,"blurHeight":0};